import { OverlayTrigger, Popover, PopoverBody } from "react-bootstrap";

const EOverlay = ({ text, iconClass = 'bi-info-circle' }) => {
    const icon = <i className={`${text ? 'text-info' : 'text-muted'} bi ${iconClass}`}></i>;

    if (!text) return icon;

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="left"
            overlay={
                <Popover className="popover-sm">
                    <PopoverBody>
                        <span dangerouslySetInnerHTML={{ __html: text.replaceAll('\n', '<BR>') }}></span>
                    </PopoverBody>
                </Popover>
            }
        >
            {icon}
        </OverlayTrigger>
    );
};

export default EOverlay;
